export const API_PATH_ApiDeviceMgmtLocationArchive = '/services/devices-mgtm/apiDeviceMgmtLocationArchive';
